import { createApi } from '@reduxjs/toolkit/query/react';
import { portalBaseQuery } from '@lib/baseQuery';

/**
 * The single catalog RTK Query slice. Endpoints are injected from sibling
 * files (`effective`, `catalogs`, `variants`, `products`, `merchantVariants`)
 * via `catalogApi.injectEndpoints` so each domain stays under the file-size
 * budget while sharing ONE reducerPath, middleware, and tag graph.
 *
 * Why one instance (not several `createApi`s like the merchant feature):
 * - The original `catalog/api.ts` stub already registered `catalogApi`
 *   (reducerPath `catalogApi`) in the store and exposed
 *   `useGetEffectiveVariantQuery` to the orders feature. Keeping a single
 *   instance preserves that contract with zero store/consumer changes.
 * - Catalog mutations must invalidate caches across domains (deleting a
 *   merchant variant must refetch the catalog's variant list). Cross-tag
 *   invalidation only works within one `createApi` instance.
 *
 * All tag types are declared here up-front because `injectEndpoints` cannot
 * add new tag types after creation.
 */
export const catalogApi = createApi({
  reducerPath: 'catalogApi',
  baseQuery: portalBaseQuery,
  tagTypes: [
    'EffectiveVariant',
    'Catalog',
    'CatalogList',
    'CatalogVariant',
    'Category',
    'Product',
    'ProductVariant',
    'ShippingGroup',
    'ShippingGroupList',
  ],
  endpoints: () => ({}),
});
